import React from 'react';
import { Switcher } from '@shared/fields';
import DatePickerField from '@shared/fields/DatePickerField';
import { addDays } from 'date-fns';
import { BoldText } from '../styles';
import { Department } from '../types';
import { Container, FilterContainer, StyledCheckbox } from './styles';

type SortOption = {
  label: string;
  value: string;
};

type DayPair = {
  label: string;
  days: string[];
};

type FiltersProps = {
  departmentFilters: Department[];
  dayPairs: DayPair[];
  handleDaysCheckboxChange: (label: string) => void;
  handleDepartmentCheckboxChange: (id: number) => void;
  selectedPairs: Record<string, boolean>;
  selectedDepartments: Record<string, boolean>;
  selectedSort: SortOption;
  handleSortChange: (value: string) => void;
  SORT_BY: SortOption[];
  isCityPage?: boolean;
  handleDateChange?: (date: Date) => void;
};

const DepartmentFilters: React.FC<{
  filters: Department[];
  selected: Record<string, boolean>;
  onChange: (id: number) => void;
}> = ({ filters, selected, onChange }) => (
  <>
    {filters.map(({ id, name }) => (
      <StyledCheckbox
        key={id}
        label={name}
        isChecked={selected[id] || false}
        onChange={() => onChange(id)}
        name={name}
        error={false}
      />
    ))}
  </>
);

const DayFilters: React.FC<{
  pairs: DayPair[];
  selected: Record<string, boolean>;
  onChange: (label: string) => void;
}> = ({ pairs, selected, onChange }) => (
  <>
    {pairs.map(({ label }) => (
      <StyledCheckbox
        key={label}
        label={label}
        isChecked={selected[label] || false}
        onChange={() => onChange(label)}
        name={label}
        error={false}
      />
    ))}
  </>
);

const Filters: React.FC<FiltersProps> = ({
  departmentFilters = [],
  dayPairs,
  handleDaysCheckboxChange,
  handleDepartmentCheckboxChange,
  selectedPairs,
  selectedDepartments,
  selectedSort,
  handleSortChange,
  SORT_BY,
  isCityPage,
  handleDateChange,
}) => (
  <Container>
    <BoldText>Affinez votre recherche</BoldText>

    <FilterContainer>
      <BoldText>Trier par</BoldText>
      <Switcher
        items={SORT_BY}
        name="sort"
        activeItem={selectedSort.value}
        onChange={(e) => handleSortChange(e.target.value)}
        disabled={false}
      />
    </FilterContainer>

    <FilterContainer>
      <BoldText>{isCityPage ? 'Par date' : 'Par département'}</BoldText>
      {isCityPage ? (
        <DatePickerField
          name="date"
          placeholder="Sélectionner"
          onChange={(name: string, dateObj: Date) =>
            handleDateChange?.(dateObj)}
          defaultDate={null}
          minDate={new Date()}
          maxDate={addDays(new Date(), 60)}
          dateFormat="dd MMMM yyyy"
          onBlur={() => {}}
        />
      ) : (
        <DepartmentFilters
          filters={departmentFilters}
          selected={selectedDepartments}
          onChange={handleDepartmentCheckboxChange}
        />
      )}
    </FilterContainer>

    <FilterContainer>
      <BoldText>Par jour</BoldText>
      <DayFilters
        pairs={dayPairs}
        selected={selectedPairs}
        onChange={handleDaysCheckboxChange}
      />
    </FilterContainer>
  </Container>
);

export { Filters };
